import React, { FC, useEffect, useState } from "react";
import PhoneIcon from "../../../assets/icons/phone.svg";
import CalendarIcon from "../../../assets/icons/calendar.svg";
import GenderIcon from "../../../assets/icons/gender.svg";
import MailIcon from "../../../assets/icons/mail.svg";
import StudentCapIcon from "../../../assets/icons/students-cap.svg";
import "./myProfile.scss";
import { Col, Row } from "antd";
import moment from "moment";
import ProfileForm from "./ProfileForm";
import AuthContainer from "../../../store/container/AuthContainer";
import UIModal from "../UIModal";

interface MyProfileProps {
  closeHandler: () => void;
  visible: boolean;
  user: any;
}
const MyProfile: FC<MyProfileProps> = ({ visible, closeHandler, user }) => {
  const [showEditProfile, setEditProfileVisibility] = useState<boolean>(false);
  return (
    <>
      <ProfileForm
        visible={showEditProfile}
        closeHandler={() => setEditProfileVisibility(false)}
        data={user}
      />
      <UIModal visible={visible} closeModal={closeHandler} noControl>
        <div>
          <div className="my-profile-modal__header">My Profile</div>
          <div className="my-profile-details__wrapper">
            <div>
              <img
                src={user?.displayPictureUrl}
                className="my-profile-modal__image"
              />
            </div>
            <div className="my-profile-details">
              <p className="my-profile-details__name">{user?.fullName}</p>
              <p className="my-profile-details__id">
                Admin<span>.</span>A0001
              </p>
              <Row className="my-profile-detail__grid">
                <Col span={24}>
                  <p className="my-profile-details-grid__item">
                    <span className="my-profile-details__icon">
                      <img src={PhoneIcon} />
                    </span>
                    {user?.phoneNumber}
                  </p>
                </Col>
                <Col span={24}>
                  <p className="my-profile-details-grid__item">
                    <span className="my-profile-details__icon">
                      <img src={MailIcon} />
                    </span>
                    {user?.email}
                  </p>
                </Col>
              </Row>
            </div>
            <div
              className="my-profile-details-edit__btn"
              onClick={() => setEditProfileVisibility(true)}
            >
              EDIT PROFILE
            </div>
          </div>
        </div>
      </UIModal>
    </>
  );
};
export default AuthContainer(MyProfile);
